/**
 * DPS / puissance : calcul exact pour le gameplay, arrondi visuel pour l’UI uniquement.
 */

import { formatUiInteger, UI_NUMBER_LOCALE } from './number_format.ts'

/** @deprecated Préférer UI_NUMBER_LOCALE */
export const POWER_DISPLAY_LOCALE = UI_NUMBER_LOCALE

/** Entier exact pour dégâts, seuils raids / expéditions et comparaisons de combat. */
export function toCombatDps(value: number): number {
  const safe = Number.isFinite(value) ? value : 0
  return Math.max(0, Math.round(safe))
}

/** Arrondi « lisible » (pastilles, inventaire) — ne jamais utiliser pour les seuils ou les dégâts. */
export function roundPowerForDisplay(value: number): number {
  const safe = Math.max(0, Number.isFinite(value) ? value : 0)
  if (safe < 100) return Math.round(safe)
  if (safe < 1_000) return Math.round(safe / 50) * 50
  if (safe < 10_000) return Math.round(safe / 500) * 500
  if (safe < 100_000) return Math.round(safe / 1_000) * 1_000
  return Math.round(safe / 5_000) * 5_000
}

export type FormatPowerDisplayOptions = {
  /** Seuils / DPS requis : valeur exacte. Défaut : arrondi visuel. */
  exact?: boolean
  locale?: string
}

/** Chaîne pour l’affichage (groupement milliers en espaces, pas la locale OS). */
export function formatPowerDisplay(value: number, options?: FormatPowerDisplayOptions): string {
  const n = options?.exact ? toCombatDps(value) : roundPowerForDisplay(value)
  return formatUiInteger(n, options?.locale)
}

/** DPS effectif combat après bonus / malus (entier exact, min 1). */
export function computeCombatEffectiveDps(
  baseTeamDps: number,
  options: {
    dpsPenaltyMult?: number
    ascensionDpsMult?: number
    combatPressureMult?: number
    goldWellDpsMult?: number
    transcendenceDpsMult?: number
    keystoneDpsMult?: number
  } = {},
): number {
  const penalty = options.dpsPenaltyMult ?? 1
  const asc = options.ascensionDpsMult ?? 1
  const pressure = options.combatPressureMult ?? 1
  const goldWell = options.goldWellDpsMult ?? 1
  const transcendence = options.transcendenceDpsMult ?? 1
  const keystone = options.keystoneDpsMult ?? 1
  return Math.max(
    1,
    toCombatDps(baseTeamDps * penalty * asc * pressure * goldWell * transcendence * keystone)
  )
}

/** @deprecated Alias affichage — préférer roundPowerForDisplay / formatPowerDisplay. */
export function roundPower(value: number): number {
  return roundPowerForDisplay(value)
}
